import UnderDevScreen from 'components/UnderDevScreen';
import MainMenu from 'components/mainMenu/MainMenu';
import { addServerConfig, getTxt } from 'global/appGlobal';
import { addAuthListener, authInfo, initFromCookie, logout } from 'global/auth';
import { addCities, addDictionaries } from 'global/dictionaryCache';
import { addDescriptors } from 'global/entityDescriptors';
import gql from 'graphql-tag';
import $ from 'jquery';
import * as Icon from '@material-ui/icons';

import { AppBar } from '@material-ui/core';
import { Drawer } from '@material-ui/core';
import { Hidden } from '@material-ui/core';
import { IconButton } from '@material-ui/core';
import { ListItemIcon, ListItemText } from '@material-ui/core';
import { Menu, MenuItem } from '@material-ui/core';
import { Toolbar } from '@material-ui/core';
import { Typography } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import LoginPage from 'modules/LoginPage';
import Broker_Details_View from 'modules/broker/Broker_Details_View';
import Broker_Search from 'modules/broker/Broker_Search';
import Client_Company_Details_Edit from 'modules/client/Client_Company_Details_Edit';
import Client_Company_View from 'modules/client/Client_Company_View';
import Client_Privat_Details_Edit from 'modules/client/Client_Privat_Details_Edit';
import Client_Privat_View from 'modules/client/Client_Privat_View';
import Client_Propspect_Privat_Details_Edit from 'modules/client/Client_Propspect_Privat_Details_Edit';
import Client_Prospect_Privat_View from 'modules/client/Client_Prospect_Privat_View';
import Client_Search from 'modules/client/Client_Search';
import Company_Details_Edit from 'modules/company/Company_Details_Edit';
import Company_Search from 'modules/company/Company_Search';
import Company_View from 'modules/company/Company_View';
import Contract_Edit from 'modules/contract/Contract_Edit';
import Contract_Item_Edit from 'modules/contract/Contract_Item_Edit';
import Contract_Item_View from 'modules/contract/Contract_Item_View';
import Contract_Search from 'modules/contract/Contract_Search';
import Contract_View from 'modules/contract/Contract_View';
import Dictionary_Item_Edit from 'modules/dictionary/Dictionary_Item_Edit';
import Dictionary_Items_Search from 'modules/dictionary/Dictionary_Items_Search';
import Dictionary_Search from 'modules/dictionary/Dictionary_Search';
import File_Edit from 'modules/file/File_Edit';
import Quote_Edit from 'modules/quote/Quote_Edit';
import Referent_Edit from 'modules/referent/Referent_Edit';
import Request_Details_Edit from 'modules/request/Request_Details_Edit';
import Request_Search from 'modules/request/Request_Search';
import Request_View from 'modules/request/Request_View';
/* eslint-disable flowtype/require-valid-file-annotation */
import PropTypes from 'prop-types';
import React from 'react';
import { graphql } from 'react-apollo';
import { Route } from 'react-router-dom';
import { Offline } from 'react-detect-offline';
import Broker_Details_Edit from '../modules/broker/Broker_Details_Edit';
import Broker_View from '../modules/broker/Broker_View';
import CompanyGuarantyEdit from '../modules/company/CompanyGuarantyEdit';
import GuarantyTypeEdit from '../modules/guaranty/GuarantyTypeEdit';
import GuarantyTypeSearch from '../modules/guaranty/GuarantyTypeSearch';
import Internal_Ins_Type_Search from '../modules/internalInsType/Internal_Ins_Type_Search';
import Internal_Ins_Type_View from '../modules/internalInsType/Internal_Ins_Type_View';
import PublicInsTypeSearch from '../modules/publicInsType/PublicInsTypeSearch';
import Public_Ins_Type_View from '../modules/publicInsType/Public_Ins_Type_View';
import Custom_Fields_Edit from '../modules/publicInsType/Custom_Fields_Edit';
import RequestGuarantyEdit from '../modules/request/RequestGuarantyEdit';
import Settings from '../modules/settings/Settings';

import ManagementDashboard from '../modules/dashboard/ManagementDashboard';
import InstallBanner from '../components/InstallBanner';
import Translations_Search from '../modules/translation/Translations_Search';
import ContractItemsReport from '../modules/reports/ContractItemsReport';
import Claim_Details_Edit from '../modules/contract/claim/Claim_Details_Edit';
import Claim_Details_View from '../modules/contract/claim/Claim_Details_View';
import ContractItemTypeSearch from '../modules/contract/Contract_Item_Type_Search';
import Broker_Payments_Search from '../modules/broker/Broker_Payments_Search';
import Client_Payments_Search from '../modules/client/Client_Payments_Search';
import Company_Payments_Search from '../modules/company/Company_Payments_Search';
import Claim_Search from '../modules/contract/claim/Claim_Search';
import ClaimsReport from '../modules/reports/ClaimsReport';
import ClaimReport_print from '../modules/reports/ClaimReport_print';
import Monthly_Inbound_Report from '../modules/reports/Monthly_Inbound_Report';
import Monthly_Inbound_Report_print from '../modules/reports/Monthly_Inbound_Report_print';
import Revenues_Insurance_Company_Report from '../modules/reports/Revenues_Insurance_Company_Report';
import ReportsRoot from '../modules/reports/ReportsRoot';
import OperationalDashboard from '../modules/dashboard/OperationalDashboard';
import Conversion_Index_Report from '../modules/reports/Conversion_Index_Report';
import PublicPaymTypeSearch from '../modules/paymentTypes/PublicPaymTypeSearch';
import Public_Payment_Type_View from '../modules/paymentTypes/Public_Payment_Type_View';
import AdminProfile from '../modules/profile/AdminProfile';
import Global_Settings_Edit from '../modules/globalSettings/Global_Settings_Edit';
import { tableMessages, filterRowMessages, getConfigValue, getClientWidth, resizeService } from '../global/appGlobal';
import ChangeLog from '../modules/ChangeLog/ChangeLog';
import { Button } from '@material-ui/core';
import Email_Templates_Search from '../modules/email-templates/Email_Templates_Search';
import Email_Template_Edit from '../modules/email-templates/Email_Template_Edit';
import QuietanzamentoReport from '../modules/reports/QuietanzamentoReport';
import TracciamentoSimpliReport from '../modules/reports/TracciamentoSimpliReport';
import ReportHeaderEdit from '../modules/reports/ReportHeaderEdit';
import SnackbarMessage from '../components/SnackbarMessage';
import Client_Search_BigData from '../modules/client/Client_Search_BigData';
import Contract_Search_BigData from '../modules/contract/Contract_Search_BigData';
import Request_Search_BigData from '../modules/request/Request_Search_BigData';
import Client_Profile_Edit from '../modules/client/Client_Profile_Edit';
import Company_Iban_Edit from '../modules/company/Company_Iban_Edit';
import Quote_View from '../modules/quote/Quote_View';
import SharedSearch from '../modules/shared-search/SharedSearch';
import Transit_Account_Search from '../modules/transit_account/Transit_Account_Search';
import Transit_Account_Type_List from '../modules/transit_account/Transit_Account_Type_List';
import { Fragment } from 'react';
import ui_dev_info from '../modules/ui_dev_info/ui_dev_info';
import PolizzeAnnullateReport from '../modules/reports/PolizzeAnnullateReport';

const drawerWidth = 248;

const styles = theme => ({
    root: {
        flexGrow: 1,
        zIndex: 1,
        overflow: 'hidden',
        position: 'relative',
        display: 'flex',
        width: '100%',
    },
    appBar: {
        backgroundColor: '#FFFFFF',
        color: '#0F172A',
        boxShadow: '0 1px 0 rgba(15, 23, 42, 0.08)',
        position: 'absolute',
        zIndex: theme.zIndex.drawer + 1,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
    },
    navIconHide: {
        [theme.breakpoints.up('md')]: {
            display: 'none',
        },
    },
    toolBar: {
        ...theme.mixins.toolbar,
        backgroundColor: '#FFFFFF',
        opacity: 1,
        minHeight: 72,
        paddingLeft: theme.spacing.unit * 2,
        paddingRight: theme.spacing.unit * 2,
        position: 'relative',
    },
    brandBar: {
        display: 'flex',
        flex: '1 1 auto',
        alignItems: 'center',
        minWidth: 0,
        height: 64,
        paddingLeft: 8,
        paddingRight: 118,
        boxSizing: 'border-box',
        overflow: 'hidden',
        [theme.breakpoints.down('sm')]: {
            height: 56,
            paddingLeft: 2,
            paddingRight: 54,
        },
    },
    mainBrand: {
        display: 'flex',
        alignItems: 'center',
        flex: '0 0 auto',
        height: 58,
        paddingRight: 12,
        borderRadius: 9,
        cursor: 'pointer',
        boxSizing: 'border-box',
        '&:hover': {
            backgroundColor: 'rgba(14, 116, 144, 0.045)',
        },
        [theme.breakpoints.down('sm')]: {
            height: 54,
            paddingRight: 4,
        },
    },
    brandSymbol: {
        display: 'block',
        flex: '0 0 48px',
        width: 48,
        height: 48,
        objectFit: 'contain',
        [theme.breakpoints.down('sm')]: {
            flexBasis: 42,
            width: 42,
            height: 42,
        },
    },
    brandSeparator: {
        display: 'block',
        flex: '0 0 1px',
        width: 1,
        height: 38,
        marginLeft: 10,
        marginRight: 11,
        backgroundColor: '#B8D9DF',
        [theme.breakpoints.down('sm')]: {
            display: 'none',
        },
    },
    brandWordmark: {
        display: 'block',
        flex: '0 0 auto',
        width: 158,
        height: 46,
        objectFit: 'contain',
        objectPosition: 'left center',
        [theme.breakpoints.down('sm')]: {
            display: 'none',
        },
    },
    brandClaim: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flex: '1 1 auto',
        minWidth: 0,
        height: 58,
        paddingLeft: 18,
        paddingRight: 18,
        overflow: 'hidden',
        [theme.breakpoints.down('md')]: {
            display: 'none',
        },
    },
    brandClaimImage: {
        display: 'block',
        width: 148,
        height: 44,
        maxWidth: '15vw',
        objectFit: 'contain',
        objectPosition: 'center',
    },
    brandTopics: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        flex: '0 1 auto',
        minWidth: 0,
        height: 58,
        gap: 5,
        overflow: 'hidden',
        [theme.breakpoints.down('md')]: {
            display: 'none',
        },
    },
    brandTopicImage: {
        display: 'block',
        flex: '0 0 auto',
        width: 47,
        height: 47,
        objectFit: 'contain',
        opacity: 0.9,
    },
    hidden: {
        backgroundColor: 'red',
        height: '3000px',
    },
    drawerPaper: {
        width: drawerWidth,
        backgroundColor: '#081C34',
        color: '#FFFFFF',
        borderRight: 0,
        boxShadow: '8px 0 30px rgba(8, 28, 52, 0.12)',
        [theme.breakpoints.up('md')]: {
            width: drawerWidth,
            position: 'relative',
            height: '100%',
        },
    },
    appFrame: {
        position: 'relative',
        display: 'flex',
        width: '100%',
        height: '100%',
    },
    content: {
        flexGrow: 1,
        backgroundColor: '#F3F6F9',
        width: `calc(100% - ${drawerWidth}px)`,
        padding: theme.spacing.unit * 2,
        height: 'calc(100% - 0px)',
        marginTop: theme.spacing.unit * 9,
        opacity: 1,
        [theme.breakpoints.up('sm')]: {
            height: 'calc(100% - 0px)',
            marginTop: theme.spacing.unit * 7,
        },
    },
    logoRoot: {
        width: '53px',
        height: '50px',
        marginRight: '10px',
        cursor: 'pointer',
        marginLeft: theme.spacing.unit * 2,
    },
    clientLogoImg: {
        // position: 'absolute',
	height: 54,                    
        maxHeight: '300%',
        marginLeft: theme.spacing.unit * 2,
        alignSelf: 'center',
        cursor: 'pointer',
        objectFit: 'contain',
        maxWidth: 240,                 
    },    userPnl: {
        whiteSpace: 'nowrap',
        width: 'auto',
    },
    button: {
        margin: theme.spacing.unit,
        position: 'absolute',
        top: 0,
        bottom: 0,
        right: theme.spacing.unit * 5,
    },
    userIcon: {
        fontSize: theme.spacing.unit * 5,
    },
    mainMenuRoot: {
        opacity: 0.967,
    },
    backBtn: {
        position: 'absolute !important',
        top: '50%',
        right: theme.spacing.unit,
        transform: 'translateY(-50%)',
        zIndex: 8,
        color: '#0F172A !important',
        backgroundColor: '#F1F5F9 !important',
        border: '1px solid #E2E8F0 !important',
        boxShadow: 'none !important',
        borderRadius: '10px !important',
    },
});

let comeBackClicked = false;

class Home extends React.Component {

    constructor(props) {
        super(props);
        this.userMenuClose = this.userMenuClose.bind(this);
        this.onLogout = this.onLogout.bind(this);
        this.onResize = this.onResize.bind(this);
        $('body').click(this.userMenuClose);
        this.handleDrawerToggle = this.handleDrawerToggle.bind(this);
        this.comeBack = this.comeBack.bind(this);

        this.showPopupInfo = this.showPopupInfo.bind(this);
        // eslint-disable-next-line no-undef
        window['showPopupInfo'] = this.showPopupInfo;
        this.hidePopupInfo = this.hidePopupInfo.bind(this);

        this.props.history.listen((location, action) => {
            if (location.pathname &&
                (location.pathname.includes('/edit/') || location.pathname.includes('/new')) && comeBackClicked) {
                this.props.history.goBack();
            }
            comeBackClicked = false;
        });

        resizeService.addResizable('home', () => {
            this.onResize();
        });
    }

    state = {
        mobileOpen: false,
        loginInfo: undefined,
        userMenuAnchor: undefined,
        userMenuOpen: false,
        popupInfoProps: false,
        backBtnText: getTxt('Back'),
        logoScale: 1,
        logoTranslate: 0,
    };

    showPopupInfo(params) {
        this.setState({ popupInfoProps: params });
    }

    hidePopupInfo() {
        this.setState({ popupInfoProps: false });
    }

    componentWillMount() {
        initFromCookie(this.props.history);
        this.setState({ loginInfo: authInfo.loginInfo });

        addAuthListener((loginInfo) => {
            this.setState({ loginInfo });
        });
    }

    componentDidMount() {
        resizeService.resizeRequest();
    }

    handleDrawerToggle = () => {
        this.setState({ mobileOpen: !this.state.mobileOpen });
    };

    userMenuClose() {
        if (this.state.userMenuOpen) {
            this.setState({ userMenuOpen: false });
        }
    }

    onLogout() {
        this.userMenuClose();
        logout();
    }

    onMenuClick(path) {
        this.props.history.push(path);
    }

    comeBack() {
        comeBackClicked = true;
        this.props.history.goBack();
    }

    onResize() {
        const w = getClientWidth();
        if (w < 730) {
            this.setState({ backBtnText: '' });
            const percentLess = w * 100 / 730;
            const scale = percentLess / 100;
            this.setState({ logoScale: scale });
            this.setState({ logoTranslate: 100 - percentLess - 5 });
        } else {
            this.setState({ backBtnText: getTxt('Back') });
            this.setState({ logoScale: 1 });
            this.setState({ logoTranslate: 0 });
        }
    }

    render() {
        const { classes, theme } = this.props;

        if (!this.props.data.loading) {
            const meta = this.props.data.allMetadata;
            if (meta && meta.entityDescriptors) {
                addDescriptors(JSON.parse(meta.entityDescriptors));
            }
            if (meta && meta.dictionaries) {
                addDictionaries(JSON.parse(meta.dictionaries));
            }
            if ((meta && meta.cities)) {
                addCities(JSON.parse(meta.cities));
            }
            if ((meta && meta.config)) {
                addServerConfig(JSON.parse(meta.config));
            }
            if ((meta && meta.translations)) {
                window.translations = JSON.parse(meta.translations);
                tableMessages.noData = getTxt('No Data');
                filterRowMessages.filterPlaceholder = getTxt('Filter...');
            }
            if ((meta && meta.globalSettings)) {
                window.globalSettings = JSON.parse(meta.globalSettings);
            }
        }

        if (this.props.data.loading) {
            return (<span>{getTxt('Loading...', '#jjpzgo0')}</span>);
        }

        return (
            <div className={classes.root}>
                <div className={classes.appFrame}>

                    {this.state.popupInfoProps && <SnackbarMessage
                        className={classes.root}
                        {...this.state.popupInfoProps}
                        onClose={this.hidePopupInfo}
                    />}

                    <AppBar className={classes.appBar}>
                        <Toolbar className={classes.toolBar}>
                            {this.state.loginInfo &&
                                <IconButton
                                    color="inherit"
                                    aria-label="open drawer"
                                    onClick={this.handleDrawerToggle}
                                    className={classes.navIconHide}
                                >
                                    <Icon.Menu />
                                </IconButton>
                            }

<div
    className={classes.mainBrand}
    role="button"
    tabIndex={0}
    aria-label="Vai alla dashboard"
    onClick={() => this.props.history.push('/')}
    onKeyDown={(event) => {
        if (
            event.key === 'Enter' ||
            event.key === ' '
        ) {
            event.preventDefault();
            this.props.history.push('/');
        }
    }}
>
    <img
        className={classes.brandSymbol}
        src="/branding/myinsurance/myinsurance-symbol.png"
        alt="My Insurance"
    />

    <span
        className={classes.brandSeparator}
        aria-hidden="true"
    />

    <div
        style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            flex: '0 0 auto',
            minWidth: 0,
            height: 56,
            marginRight: 15,
            lineHeight: 1,
        }}
    >
        <Typography
            component="span"
            color="inherit"
            style={{
                display: 'block',
                color: '#0F172A',
                fontSize: 22,
                lineHeight: '26px',
                fontWeight: 400,
                whiteSpace: 'nowrap',
                letterSpacing: '-0.015em',
            }}
        >
            My Insurance
        </Typography>

        <Typography
            component="span"
            color="inherit"
            style={{
                display: 'block',
                marginTop: 1,
                color: '#087187',
                fontSize: 10,
                lineHeight: '13px',
                fontWeight: 400,
                fontStyle: 'italic',
                whiteSpace: 'nowrap',
                letterSpacing: '0.01em',
            }}
        >
            {'Pi\u00f9 vita ai tuoi progetti'}
        </Typography>
    </div>
</div>
				<div
                                    className={classes.brandTopics}
                                    aria-label="Aree assicurative"
                                >
                                    <img
                                        className={classes.brandTopicImage}
                                        src="/branding/myinsurance/02_persone.png"
                                        alt="Persone"
                                    />
                                    <img
                                        className={classes.brandTopicImage}
                                        src="/branding/myinsurance/03_casa.png"
                                        alt="Casa"
                                    />
                                    <img
                                        className={classes.brandTopicImage}
                                        src="/branding/myinsurance/04_mobilita.png"
                                        alt="Mobilit�"
                                    />
                                    <img
                                        className={classes.brandTopicImage}
                                        src="/branding/myinsurance/05_famiglia.png"
                                        alt="Famiglia"
                                    />
                                </div>

                                <div className={classes.brandClaim}>
                                    <img
                                        className={classes.brandClaimImage}
                                        src="/branding/myinsurance/01_claim_un_domani_piu_sereno_insieme.png"
                                        alt="Un domani pi� sereno, insieme"
                                    />
                                </div>

                                
                            

                            {this.props.history.location.pathname !== '/' &&
                                this.props.history.location.pathname !== '/login' &&
                                <Fragment>
                                    {getClientWidth() > 730 &&
                                        <Button
                                            className={classes.backBtn}
                                            onClick={this.comeBack}
                                            color="primary"
                                            variant="contained"
                                            size="medium"
                                            id="backButton"
                                        >
                                            <Icon.NavigateBefore />
                                            Indietro
                                        </Button>
                                    }
                                    {getClientWidth() < 730 &&
                                        <IconButton
                                            aria-label={getTxt('Come Back')}
                                            className={classes.backBtn}
                                            onClick={this.comeBack}
                                            id="backButton"
                                        >
                                            <Icon.NavigateBefore />
                                        </IconButton>
                                    }
                                </Fragment>
                            }
                        </Toolbar>
                    </AppBar>

                    <Hidden mdUp className={classes.hidden}>
                        <Drawer
                            variant="temporary"
                            anchor={theme.direction === 'rtl' ? 'right' : 'left'}
                            open={this.state.mobileOpen}
                            onClose={this.handleDrawerToggle}
                            classes={{
                                paper: classes.drawerPaper,
                            }}
                            ModalProps={{
                                keepMounted: true,
                            }}
                        >
                            {this.state.loginInfo && <MainMenu history={this.props.history} onClose={this.handleDrawerToggle} />}
                        </Drawer>
                    </Hidden>

                    <Hidden smDown implementation="css">
                        {this.state.loginInfo && <Drawer
                            variant="permanent"
                            open
                            classes={{
                                paper: classes.drawerPaper,
                            }}
                        >
                            <MainMenu history={this.props.history} />
                        </Drawer>}
                    </Hidden>

                    <main className={classes.content}>
                        {authInfo && !authInfo.loginInfo &&
                            <div>
                                <Route path="/login" component={LoginPage} />
                                <Route exact path="/" component={LoginPage} />
                            </div>
                        }

                        {authInfo && authInfo.loginInfo &&
                            <div>
                                <Route exact path="/customers/all" component={Client_Search_BigData} />
                                <Route exact path="/customers/filterx/:filter" component={Client_Search_BigData} />
                                <Route exact path="/customers/filter/:filter" component={Client_Search} />
                                <Route exact path="/customers" component={Client_Search} />
                                <Route exact path="/customers/private/:id" component={Client_Privat_View} />
                                <Route exact path="/customers/private/edit/:id" component={Client_Privat_Details_Edit} />
                                <Route exact path="/customers/new/private" component={Client_Privat_Details_Edit} />
                                <Route exact path="/customers/private/edit/:id/toreal/:toReal" component={Client_Privat_Details_Edit} />

                                <Route exact path="/customers/company/:id" component={Client_Company_View} />
                                <Route exact path="/customers/company/edit/:id" component={Client_Company_Details_Edit} />
                                <Route exact path="/customers/new/company/" component={Client_Company_Details_Edit} />
                                <Route exact path="/customers/prospect/private/:id/" component={Client_Prospect_Privat_View} />
                                <Route exact path="/customers/prospect/private/edit/:id" component={Client_Propspect_Privat_Details_Edit} />
                                <Route exact path="/customers/new/prospect/private/" component={Client_Propspect_Privat_Details_Edit} />

                                <Route exact path="/customers/payments/all" component={Client_Payments_Search} />

                                <Route exact path="/requests" component={Request_Search} />
                                <Route exact path="/requests/all" component={Request_Search_BigData} />
                                <Route exact path="/requests/filter/:filter" component={Request_Search} />
                                <Route exact path="/requests/:insType/view/:id" component={Request_View} />
                                <Route exact path="/requests/:insType/:customerId/new" component={Request_Details_Edit} />
                                <Route exact path="/requests/:insType/edit/:customerId/:id" component={Request_Details_Edit} />

                                <Route exact path="/quotes/edit/:requestId/:id" component={Quote_Edit} />
                                <Route exact path="/quotes/view/:requestId/:id" component={Quote_View} />

                                <Route exact path="/documents/edit/:id" component={File_Edit} />
                                <Route exact path="/brokers/view/:id" component={Broker_Details_View} />

                                <Route exact path="/reports" component={ReportsRoot} />
                                <Route exact path="/reports/contracts" component={ContractItemsReport} />
                                <Route exact path="/reports/contracts/non-perfezionati" component={ContractItemsReport} />
                                <Route exact path="/reports/quietanzamento" component={QuietanzamentoReport} />
                                <Route exact path="/reports/tracciamento-simpli" component={TracciamentoSimpliReport} />
                                <Route exact path="/reports/polizze-annullate" component={PolizzeAnnullateReport} />

                                <Route exact path="/ui_info" component={ui_dev_info} />

                                {authInfo.isCustomer() &&
                                    <Route exact path="/" component={Contract_Search_BigData} />
                                }
                                {!authInfo.isCustomer() &&
                                    <Route exact path="/company/search" component={Company_Search} />
                                }
                                <Route exact path="/company/view/:id" component={Company_View} />
                                <Route exact path="/company/edit/:id" component={Company_Details_Edit} />

                                {(authInfo.isAgencyAdministrator() || authInfo.isMasterBroker() || authInfo.isBroker() || authInfo.isSubBroker()) &&
                                    <Route exact path="/companies/payments/all" component={Company_Payments_Search} />
                                }
                                {(authInfo.isAgencyAdministrator() || authInfo.isMasterBroker() || authInfo.isBroker() || authInfo.isSubBroker()) &&
                                    <Route exact path="/changelog" component={ChangeLog} />
                                }

                                <Route exact path="/dictionaries/:dictionaryId/items/:id" component={Dictionary_Item_Edit} />
                                <Route exact path="/dictionaries/:dictionaryId/new" component={Dictionary_Item_Edit} />
                                <Route exact path="/dictionaries/:dictionaryId/items" component={Dictionary_Items_Search} />
                                <Route exact path="/dictionaries/" component={Dictionary_Search} />

                                <Route exact path="/contracts/all" component={Contract_Search_BigData} />
                                <Route exact path="/contracts" component={Contract_Search} />
                                <Route exact path="/contracts/filter/:filter" component={Contract_Search} />
                                <Route exact path="/contract/view/:insType/:id" component={Contract_View} />
                                <Route exact path="/contract/edit/:insType/:requestId" component={Contract_Edit} />
                                <Route exact path="/contract/edit/:insType/:requestId/:id" component={Contract_Edit} />
                                <Route exact path="/contract/:insType/:contractId/item/:id" component={Contract_Item_Edit} />
                                <Route exact path="/contract/:insType/:contractId/quietanza/:id" component={Contract_Item_Edit} />
                                <Route exact path="/contract/:insType/:contractId/item/view/:id" component={Contract_Item_View} />

                                <Route exact path="/contract/:contractId/claim/:claimId" component={Claim_Details_Edit} />
                                <Route exact path="/contract/:contractId/claim/view/:claimId" component={Claim_Details_View} />
                                <Route exact path="/contract_items_types" component={ContractItemTypeSearch} />

                                <Route exact path="/claims" component={Claim_Search} />
                                <Route exact path="/claims/filter/:filter" component={Claim_Search} />

                                <Route exact path="/referents/edit/:parentId/:id" component={Referent_Edit} />

                                {(authInfo.isAgencyAdministrator() || authInfo.isMasterBroker() || authInfo.isBroker()) &&
                                    <Route exact path="/brokers" component={Broker_Search} />
                                }
                                {(authInfo.isAgencyAdministrator() || authInfo.isMasterBroker() || authInfo.isBroker() || authInfo.isSubBroker()) &&
                                    <Route exact path="/brokers/payments/all" component={Broker_Payments_Search} />
                                }

                                <Route exact path="/brokers/:id" component={Broker_View} />

                                {(authInfo.isAgencyAdministrator() || authInfo.isMasterBroker() || authInfo.isBroker()) &&
                                    <Route exact path="/brokers/edit/:id" component={Broker_Details_Edit} />
                                }
                                {(authInfo.isSubBroker()) &&
                                    <Route exact path="/brokers/edit/:id" component={Broker_Details_View} />
                                }

                                <Route exact path="/guaranty_types" component={GuarantyTypeSearch} />
                                <Route exact path="/guaranty_types/:id" component={GuarantyTypeEdit} />
                                <Route exact path="/guaranty_types/:id/for_ins_type/:insType" component={GuarantyTypeEdit} />

                                <Route exact path="/company_guaranties/:companyId/:id" component={CompanyGuarantyEdit} />
                                <Route exact path="/guaranty/:requestId/:id" component={RequestGuarantyEdit} />
                                <Route exact path="/guaranty/:requestId/:id/:contractId" component={RequestGuarantyEdit} />

                                <Route exact path="/insurance_types" component={PublicInsTypeSearch} />
                                <Route exact path="/public_ins_type/view/:id" component={Public_Ins_Type_View} />
                                <Route exact path="/public_ins_type/:id/edit_fields" component={Custom_Fields_Edit} />

                                <Route exact path="/real_insurance_types" component={Internal_Ins_Type_Search} />
                                <Route exact path="/real_insurance_types/view/:id" component={Internal_Ins_Type_View} />

                                <Route exact path="/payment_types" component={PublicPaymTypeSearch} />
                                <Route exact path="/public_payment_type/view/:id" component={Public_Payment_Type_View} />

                                {authInfo.isAgencyAdministrator() &&
                                    <Route exact path="/ui_translation" component={Translations_Search} />
                                }

                                {(authInfo.isAgencyAdministrator() || authInfo.isMasterBroker() || authInfo.isBroker()) &&
                                    <Route exact path="/reports/claims" component={ClaimsReport} />
                                }
                                {(authInfo.isAgencyAdministrator() || authInfo.isMasterBroker() || authInfo.isBroker()) &&
                                    <Route exact path="/reports/claims/print/:from/:to/:companyId" component={ClaimReport_print} />
                                }
                                {(authInfo.isAgencyAdministrator() || authInfo.isMasterBroker() || authInfo.isBroker()) &&
                                    <Route exact path="/reports/monthly-inbound" component={Monthly_Inbound_Report} />
                                }
                                {(authInfo.isAgencyAdministrator() || authInfo.isMasterBroker() || authInfo.isBroker()) &&
                                    <Route exact path="/reports/monthly-inbound/print" component={Monthly_Inbound_Report_print} />
                                }
                                {(authInfo.isAgencyAdministrator() || authInfo.isMasterBroker() || authInfo.isBroker()) &&
                                    <Route exact path="/reports/revenues-company" component={Revenues_Insurance_Company_Report} />
                                }
                                {(authInfo.isAgencyAdministrator() || authInfo.isMasterBroker() || authInfo.isBroker()) &&
                                    <Route exact path="/reports/conversion-index" component={Conversion_Index_Report} />
                                }

                                {(authInfo.isAgencyAdministrator() || authInfo.isMasterBroker() || authInfo.isSubBroker()) &&
                                    <Route exact path="/dashboard/management" component={ManagementDashboard} />
                                }
                                {(authInfo.isBroker() || authInfo.isSubBroker() || authInfo.isAgencyAdministrator() || authInfo.isMasterBroker()) &&
                                    <Route exact path="/" component={OperationalDashboard} />
                                }
                                {(authInfo.isAgencyAdministrator() || authInfo.isMasterBroker() || authInfo.isBroker() || authInfo.isSubBroker()) &&
                                    <Route exact path="/dashboard/operational" component={OperationalDashboard} />
                                }
                                {(authInfo.isAgencyAdministrator()) &&
                                    <Route exact path="/admin/profile" component={AdminProfile} />
                                }
                                {(authInfo.isCompany()) &&
                                    <Route exact path="/company/profile" component={() => <Company_Details_Edit isProfile />} />
                                }
                                {(authInfo.isBroker()) &&
                                    <Route exact path="/broker/profile" component={() => <Broker_Details_Edit isProfile />} />
                                }
                                {(authInfo.isCustomer()) &&
                                    <Route exact path="/customer/profile" component={() => <Client_Profile_Edit />} />
                                }

                                {(authInfo.isAgencyAdministrator() || authInfo.isMasterBroker()) &&
                                    <Route exact path="/conti_transito" component={Transit_Account_Type_List} />
                                }
                                {(authInfo.isAgencyAdministrator() || authInfo.isMasterBroker()) &&
                                    <Route exact path="/conti_transito/:payment_account" component={Transit_Account_Search} />
                                }
                                {(authInfo.isAgencyAdministrator() || authInfo.isMasterBroker()) &&
                                    <Route exact path="/settings" component={Global_Settings_Edit} />
                                }
                                {(authInfo.isAgencyAdministrator() || authInfo.isMasterBroker()) &&
                                    <Route exact path="/email_templates" component={Email_Templates_Search} />
                                }
                                {(authInfo.isAgencyAdministrator() || authInfo.isMasterBroker()) &&
                                    <Route exact path="/email_template/:id" component={Email_Template_Edit} />
                                }
                                {(authInfo.isAgencyAdministrator() || authInfo.isMasterBroker()) &&
                                    <Route exact path="/reports_header" component={ReportHeaderEdit} />
                                }
                                {(authInfo.isAgencyAdministrator() || authInfo.isMasterBroker()) &&
                                    <Route exact path="/iban/edit/:id" component={Company_Iban_Edit} />
                                }
                                {(authInfo.isAgencyAdministrator() || authInfo.isMasterBroker() || authInfo.isBroker()) && getConfigValue('partnerAgencies') && getConfigValue('partnerAgencies').length > 0 &&
                                    <Route exact path="/shared-search" component={SharedSearch} />
                                }

                                <Route path="/login" component={LoginPage} />
                                <Route path="/underdev" component={UnderDevScreen} />
                            </div>
                        }
                    </main>
                </div>
            </div>
        );
    }
}

Home.propTypes = {
    classes: PropTypes.object.isRequired,
    theme: PropTypes.object.isRequired,
};

export const metadataQuery = gql`
    query allmetaQuery{
        allMetadata {
            entityDescriptors
            dictionaries
            config
            translations
        }
    }
`;

export default graphql(metadataQuery, {
    options: {
        errorPolicy: 'all',
    },
})(withStyles(styles, { withTheme: true })(Home));